module.exports = __webpack_public_path__ + "img/Grupo 15080.a42f00dc.svg";